import { TooltipV2 } from '@cimplico/components';
import { ClipboardDocumentCheckIcon, DocumentTextIcon } from '@heroicons/react/20/solid';
import { useSearchParams } from 'react-router-dom';

type WorkpaperProceduresTopActionsProps = {
    firstProcedureId?: string;
};

export default function WorkpaperProceduresTopActions({ firstProcedureId }: WorkpaperProceduresTopActionsProps): JSX.Element {
    return (
        <div className="flex gap-1">
            <WorkpaperProceduresTopAction
                icon={<ClipboardDocumentCheckIcon className="h-5 w-5" />}
                id="procedureDetails"
                firstProcedureId={firstProcedureId}
                hint="Procedure details"
            />
            <WorkpaperProceduresTopAction icon={<DocumentTextIcon className="h-5 w-5" />} id="notes" hint="Notes" />
        </div>
    );
}

type WorkpaperProceduresTopActionProps = {
    icon: JSX.Element;
    id: string;
    firstProcedureId?: string;
    hint?: string;
};

function WorkpaperProceduresTopAction({ icon, id, firstProcedureId, hint }: WorkpaperProceduresTopActionProps): JSX.Element {
    const [search, setSearch] = useSearchParams();

    const isActive = search.get('addon') === id;

    function toggleAddon(): void {
        setSearch(
            (s) => {
                // always reset activeProcedureId when found
                if (search.get('activeProcedure')) {
                    s.delete('activeProcedure');
                }

                if (isActive) {
                    s.delete('addon');
                } else {
                    s.set('addon', id);
                    if (id === 'procedureDetails' && firstProcedureId) {
                        s.set('activeProcedure', firstProcedureId);
                    }
                }
                return s;
            },
            { replace: true }
        );
    }

    return (
        <TooltipV2 delayMs={750} message={hint} disabled={!hint}>
            <div
                className={`py-2 px-2.5 cursor-pointer rounded-md ${
                    isActive ? 'bg-indigo-50 text-indigo-600' : 'text-gray-600 hover:bg-gray-50'
                }`}
                onClick={toggleAddon}
            >
                {icon}
            </div>
        </TooltipV2>
    );
}
